import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './i18n'; // Initialize i18n
import { initializePageCache } from './utils/pageCache';
import App from './App';

// Initialize page cache (clears on refresh)
initializePageCache();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
